export default function parseBlobError(e) {
  return new Promise((resolve, reject) => {
    if (!e.response) return reject(e);
    const reader = new FileReader();
    reader.addEventListener('abort', reject);
    reader.addEventListener('error', reject);
    reader.addEventListener('loadend', () => {
      resolve(JSON.parse(reader.result));
    });
    return reader.readAsText(e.response.data);
  });
}
